/* PATOYS pages: policy layout (tabs, collapsible sections), article contents, copy link, tap-to-load map. No dependencies. */
(function () {
  'use strict';
  var dataNode = document.getElementById('pt-pages-data');
  var D = {};
  try {
    D = JSON.parse(dataNode.textContent);
  } catch (e) {
    D = {};
  }
  var T = D.t || {};

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- Policy pages ---------- */
  function policy() {
    var box = document.querySelector('.shopify-policy__container');
    if (!box || box.getAttribute('data-ptp') === '1') return;
    box.setAttribute('data-ptp', '1');
    box.classList.add('ptp-policy');
    var title = box.querySelector('.shopify-policy__title');
    var body = box.querySelector('.shopify-policy__body');
    if (!title || !body) return;

    var head = el('div', 'ptp-policy__head');
    var crumb = el('nav', 'ptp-crumb');
    crumb.setAttribute('aria-label', T.crumbAria || 'Breadcrumb');
    var a = el('a', '', T.home || 'Home');
    a.href = '/';
    crumb.appendChild(a);
    crumb.appendChild(el('span', '', '/'));
    crumb.appendChild(el('span', '', T.policiesAria || 'Policies'));
    head.appendChild(crumb);

    var tabs = el('nav', 'ptp-tabs');
    tabs.setAttribute('aria-label', T.policiesAria || 'Policies');
    (D.policies || []).forEach(function (p) {
      var t = el('a', 'ptp-tab' + (p.current ? ' is-current' : ''), p.title);
      t.href = p.url;
      if (p.current) t.setAttribute('aria-current', 'page');
      tabs.appendChild(t);
    });
    head.appendChild(tabs);
    box.insertBefore(head, title);
    head.appendChild(title);

    var text = body.textContent || '';
    var m = text.match(/(Effective|Last updated|Last Updated)\s*:?\s*([0-9]{1,2}\s+[A-Za-z]+\s+[0-9]{4})/);
    if (m) head.appendChild(el('p', 'ptp-updated', (T.updated || 'Last updated') + ': ' + m[2]));

    // highlight "Our policy in one line" box
    var walker = body.querySelectorAll('div, p, section');
    for (var i = 0; i < walker.length; i++) {
      var w = walker[i];
      if (w.children.length && w.textContent.trim().indexOf('Our policy in one line') === 0 && w.textContent.length < 1200) {
        w.classList.add('ptp-oneline');
        break;
      }
    }

    // split by h2 into collapsible sections (text and order unchanged, nodes are only moved)
    var h2s = body.querySelectorAll('h2');
    if (h2s.length > 1) {
      var parent = h2s[0].parentNode;
      var all = Array.prototype.filter.call(h2s, function (h) {
        return h.parentNode === parent;
      });
      if (all.length > 1) {
        var bar = el('div', 'ptp-bar');
        bar.appendChild(el('span', 'ptp-bar__t', T.sections || 'Sections'));
        var btns = el('div', 'ptp-bar__b');
        var ex = el('button', 'ptp-link', T.expandAll || 'Expand all');
        var co = el('button', 'ptp-link', T.collapseAll || 'Collapse all');
        ex.type = 'button';
        co.type = 'button';
        btns.appendChild(ex);
        btns.appendChild(co);
        bar.appendChild(btns);
        parent.insertBefore(bar, all[0]);
        var details = [];
        all.forEach(function (h, idx) {
          var d = el('details', 'ptp-sec');
          var s = el('summary', 'ptp-sec__sum');
          parent.insertBefore(d, h);
          s.appendChild(h);
          d.appendChild(s);
          var n = d.nextSibling;
          var stop = all[idx + 1];
          while (n && n !== stop) {
            var next = n.nextSibling;
            if (n.nodeType === 1 && n.classList && n.classList.contains('ptp-sec')) break;
            d.appendChild(n);
            n = next;
          }
          if (idx === 0) d.open = true;
          details.push(d);
        });
        ex.addEventListener('click', function () {
          details.forEach(function (d) {
            d.open = true;
          });
        });
        co.addEventListener('click', function () {
          details.forEach(function (d) {
            d.open = false;
          });
        });
      }
    }

    var q = el('div', 'ptp-ask');
    var qt = el('div', '');
    qt.appendChild(el('strong', '', T.question || ''));
    qt.appendChild(el('span', '', T.hours || ''));
    q.appendChild(qt);
    var wa = el('a', 'ptp-btn ptp-btn--wa', '');
    var wi = document.createElement('img');
    wi.src = 'https://cdn.shopify.com/s/files/1/0765/6987/0654/files/patoys-logo.jpg?v=1744571126';
    wi.alt = 'WhatsApp';
    wi.width = 20;
    wi.height = 20;
    wi.loading = 'lazy';
    wi.style.cssText = 'border-radius:50%;object-fit:cover';
    wa.appendChild(wi);
    wa.appendChild(document.createTextNode(' +91 80101 10811'));
    wa.href = 'https://wa.me/918010110811';
    wa.target = '_blank';
    wa.rel = 'noopener';
    q.appendChild(wa);
    box.appendChild(q);
  }

  /* ---------- Article: contents from the article's own h2s ---------- */
  function article() {
    var body = document.querySelector('.ptp-article__body');
    var toc = document.querySelector('[data-ptp-toc]');
    if (!body || !toc) return;
    var hs = body.querySelectorAll('h2');
    if (!hs.length) {
      var box = toc.closest('.ptp-aside__box');
      if (box) box.hidden = true;
      return;
    }
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (i + 1);
      var a = el('a', '', h.textContent.trim());
      a.href = '#' + h.id;
      toc.appendChild(a);
    });
    var faq = document.getElementById('ptp-faq');
    if (faq) {
      var f = el('a', '', toc.getAttribute('data-faq') || 'FAQ');
      f.href = '#ptp-faq';
      toc.appendChild(f);
    }
  }

  /* ---------- Copy link, map ---------- */
  document.querySelectorAll('[data-ptp-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-ptp-copy');
      var label = b.textContent;
      var done = function () {
        b.textContent = T.copied || 'Copied';
        setTimeout(function () {
          b.textContent = label;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
    });
  });
  document.querySelectorAll('[data-ptp-map]').forEach(function (m) {
    var btn = m.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = m.getAttribute('data-ptp-map');
      f.loading = 'lazy';
      f.title = btn.textContent;
      m.textContent = '';
      m.appendChild(f);
    });
  });

  policy();
  article();
})();